export const Base_Url_Landing_Page_Backend="https://api.ezsync.in"
export const Base_Url_Landing_Page_Frontend="https://ezsync.in"
export const baseUrl="https://api-interview.ezsync.in"



//Uncomment for local run

// export const Base_Url_Landing_Page_Backend="http://localhost:9000"
// export const Base_Url_Landing_Page_Frontend="http://localhost:3000"
// export const baseUrl="http://localhost:8080"